import { useState } from "react";

export const ItemImage = (props: React.ComponentProps<"img">) => {
  const { src, alt, ...rest } = props;
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <img
      src={imgSrc}
      alt={alt}
      draggable={false}
      onError={() => setImgSrc("/img/Logos/Game_Logo.png")}
      {...rest}
    />
  );
};
